<template>
  <div class="pb-2 section">
    <div class="container">
      <div class="container__inner px-1.5">
        <p class="p-0 py-2 m-0 text-xl lg:text-4xl lg:pb-2" id="quiz_block">
          {{ question.title }}
        </p>

        <div
          v-if="question.description"
          class="pb-2"
          v-html="question.description"
        ></div>

        <div v-if="question.media" class="pb-2">
          <img :src="question.media.guid" />
        </div>

        <form name="quiz-form" class="quiz-form" method="post">
          <div class="flex flex-wrap justify-between w-full">
            <div class="lg:w-10/12">
              <draggable v-model="answers" @end="change()" item-key="id">
                <template #item="{ element, index }">
                  <div class="flex items-center w-full mb-1 question-item">
                    <div
                      class="flex-shrink-0 p-1.5 question-rank text-lg lg:text-xl font-medium"
                    >
                      {{ index + 1 }}
                    </div>
                    <div
                      class="relative flex items-center bg-white question-drag-item border border-solid border-dark rounded-2xl p-1.5 text-sm lg:text-lg flex-1"
                    >
                      <span>{{ element.title }}</span>
                    </div>
                  </div>
                </template>
              </draggable>
            </div>
          </div>
          <!-- .grid -->
          <div class="py-2 lg:py-4">
            <button
              type="button"
              class="bt"
              @click="$emit('nextQuestion')"
              :disabled="choices.length === 0"
            >
              <span>Question suivante</span>
            </button>
          </div>
        </form>
      </div>
      <!-- .container__inner -->
    </div>
    <!-- .container -->
  </div>
  <!-- .section -->
</template>
<script setup>
import { ref } from "vue";
import draggable from "vuedraggable";
const props = defineProps({
  question: {
    type: Object,
    required: true,
  },
  modelValue: {
    type: Array,
    required: true,
  },
});

// https://stackoverflow.com/questions/33604137/how-do-i-shuffle-a-javascript-array-ensuring-each-index-is-in-a-new-position-in
const shuffle = (items) => {
  for (var i = items.length; i-- > 1; ) {
    var j = Math.floor(Math.random() * i);
    var tmp = items[i];
    items[i] = items[j];
    items[j] = tmp;
  }

  return items;
};

const answers = ref(shuffle(Object.values(props.question.answers)));
const emit = defineEmits(["update:modelValue", "nextQuestion"]);
const choices = ref(props.modelValue);
const change = () => {
  choices.value = answers.value.map((a) => a.id);
  emit("update:modelValue", choices.value);
};
</script>
